import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=4f39f75e&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39f75e",
  null
  
)

export default component.exports